const PROJECTS = [
  {
    title: 'Beastgrip',
    description: 'A fast-growing e-commerce website and blog for an advanced mobile photography and filmmaking hardware startup based out of Chicago, IL.',
    url: 'https://beastgrip.com',
    id: 5,
  },
  {
    title: 'Mail For Good',
    description: 'A documentation website for Mail For Good, a trending email marketing software platform from the non-profit organization Free Code Camp.',
    url: 'http://mail-for-good.netlify.com',
    id: 4,
  },
  /* {
    title: 'Chicago Web Developers',
    description: 'A landing page website for Chicago Web Developers, an innovative local web development consultancy.',
    url: 'https://chicagowebdevelopers.co',
    id: 3,
  }, */
  {
    title: 'Mobile Innovation Network Australasia',
    description: 'A full-featured website and blog for an influential mobile filmmaking non-profit organization in Australia.',
    url: 'http://mina.pro',
    id: 2,
  },
  {
    title: 'Miller Street Studios',
    description: 'A landing page and blog website for a specialized Chicago-based audio recording studio.',
    url: 'http://millerstreetstudios.com',
    id: 1,
  }
]

export default PROJECTS



// WEBPACK FOOTER //
// ./src/data/PROJECTS.js